export default "/assets/user_zendesk_light-f228e223cd4bf79051e2739204941aef213b3f0020af826b3497a8f9ea5b30f2.svg";